import { translateLabel } from "@/i18n/messages";
import React from "react";
import { DIFFICULTY } from "@/lib/apiClient";

const ORDER = ["easy", "intermediate", "advanced", "expert"];

export function DifficultyBar({ distribution, className = "" }) {
  const total = ORDER.reduce((s, k) => s + (distribution[k] || 0), 0) || 1;
  return (
    <div className={`flex h-1.5 w-full overflow-hidden rounded-full bg-white/5 ${className}`} data-testid="difficulty-bar">
      {ORDER.map((k) => {
        const v = distribution[k] || 0;
        if (!v) return null;
        return (
          <div
            key={k}
            style={{ width: `${(v / total) * 100}%`, backgroundColor: DIFFICULTY[k].color }}
            className="h-full"
          />
        );
      })}
    </div>
  );
}

export function DifficultyLegend({ distribution }) {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1" data-testid="difficulty-legend">
      {ORDER.map((k) => {
        const v = distribution[k] || 0;
        if (!v) return null;
        return (
          <span key={k} className="flex items-center gap-1.5 text-xs font-semibold text-zinc-300">
            <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ backgroundColor: DIFFICULTY[k].color }} />
            {v} {translateLabel(DIFFICULTY[k].label)}
          </span>
        );
      })}
    </div>
  );
}
